import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getProductsService,
  showProductService,
  reviewProductService,
  returnProductService,
  getReturnOrderDetailsService,
  getEstimatedDeliveryService,
  getProductReviewsService,
  getAllServices,
  getSearchProductSuggestionService,
  clearSearchHistorySuggestionService,
  getSearchHistoryProductSuggestionService,
} from "../../services/product.service";
// import { getRewardsService, showRewardService } from "../../services/reward.service"
import {
  getMerchantServiceService,
  getMerchantServicesService,
} from "../../services/merchant.service";

import { ImageCacheManager } from "store/utils/imageCache";

const imageCacheManager = new ImageCacheManager("productVariations");

export const getProducts = createAsyncThunk(
  "/getProducts",
  async (params, { rejectWithValue }) => {
    let response;

    switch (params.type) {
      case "REWARDS":
        response = await getProductsService(params, rejectWithValue);
        break;
      case "SERVICES":
        delete params.type;
        response = await getMerchantServicesService(params, rejectWithValue);
        break;
      case "products":
      default:
        response = await getProductsService(params, rejectWithValue);
        break;
    }

    if (response?.d?.list?.length) {
      const cachedList = await Promise.all(
        response.d.list.map(async (item) => {
          let url = await imageCacheManager.getCachedImageVariationById(
            item.id
          );

          if (!url && item.image) {
            await imageCacheManager.setCachedImageVariationById(
              item.id,
              item.image
            );
            url = item.image;
          }

          return {
            ...item,
            image: url,
          };
        })
      );

      response = {
        ...response,
        d: {
          ...response.d,
          list: cachedList,
        },
      };
    }

    return response;
  }
);

export const getServices = createAsyncThunk(
  "/getServices",
  async (payload, { rejectWithValue }) => {
    return await getAllServices(payload, rejectWithValue);
  }
);

export const showProduct = createAsyncThunk("/showProduct", async (params) => {
  let result;

  switch (params.type) {
    case "REWARDS":
      delete params.type;
      result = await showProductService(params.id);
      break;
    case "SERVICES":
      delete params.type;
      result = await getMerchantServiceService(params.id);
      break;
    default:
      delete params.type;
      result = await showProductService(params.id);
      break;
  }

  const data = result?.d;

  if (data?.variation?.length) {
    const variationWithCachedImages = await Promise.all(
      data.variation.map(async (variation) => {
        let url = await imageCacheManager.getCachedImageVariationById(
          variation.id
        );

        if (!url && variation.image) {
          await imageCacheManager.setCachedImageVariationById(
            variation.id,
            variation.image
          );
          url = variation.image;
        }

        return {
          ...variation,
          image: url,
          selected: false,
        };
      })
    );

    return {
      d: {
        ...data,
        ...data.variation[0],
        id: data.id,
        productName: data.name,
        productId: data.id,
        variation: variationWithCachedImages,
      },
    };
  }

  return {
    d: {
      ...data,
      productName: data?.name,
      productId: data?.id,
    },
  };
});

export const getProductReviewsAction = createAsyncThunk(
  "/getProductReviews",
  async (payload, { rejectWithValue }) => {
    return await getProductReviewsService(payload, rejectWithValue);
  }
);

export const addProductReview = createAsyncThunk(
  "/addProductReview",
  async (payload, { rejectWithValue }) => {
    return await reviewProductService(payload, rejectWithValue);
  }
);

export const returnProduct = createAsyncThunk(
  "/returnProduct",
  async (payload, { rejectWithValue }) => {
    return await returnProductService(payload, rejectWithValue);
  }
);

export const getReturnOrderDetails = createAsyncThunk(
  "/getReturnOrderDetails",
  async (payload, { rejectWithValue }) => {
    console.log("getReturnOrderDetailsService Triggered");
    return await getReturnOrderDetailsService(payload, rejectWithValue);
  }
);

export const getEstimatedDelivery = createAsyncThunk(
  "/getEstimatedDelivery",
  async (payload, { rejectWithValue }) => {
    return await getEstimatedDeliveryService(payload, rejectWithValue);
  }
);

export const getSearchProductsSuggestion = createAsyncThunk(
  "/getSearchProductsSuggestion",
  async (params, { rejectWithValue }) => {
    return await getSearchProductSuggestionService(params, rejectWithValue);
    // switch (params.type) {
    //   case "REWARDS":
    //     // delete params.type;
    //     return await getProductsService(params, rejectWithValue);
    //   case "SERVICES":
    //     delete params.type;
    //     return await getMerchantServicesService(params, rejectWithValue);
    //   case "products":
    //     // delete params.type;
    //     return await getSearchProductSuggestionService(params, rejectWithValue);
    //   default:
    //     // delete params.type;
    //     return await getSearchProductSuggestionService(params, rejectWithValue);
    // }
  }
);

export const getSearchHistoryProductsSuggestion = createAsyncThunk(
  "/getSearchHistoryProductsSuggestion",
  async (params, { rejectWithValue }) => {
    return await getSearchHistoryProductSuggestionService(
      params,
      rejectWithValue
    );
  }
);

export const clearSearchHistorySuggestion = createAsyncThunk(
  "/clearSearchHistorySuggestion",
  async (params, { rejectWithValue }) => {
    return await clearSearchHistorySuggestionService(params, rejectWithValue);
  }
);
